import ChoiceListSection from './ChoiceListSection.jsx';

const PrioritySection = ({ section }) => (
  <ChoiceListSection
    section={section}
    control="checkbox"
    multiple
    maxVisible={section.maxVisible ?? 5}
  />
);

export default PrioritySection;
